/* <tc> tag cleanup voor T Lab (was inline in layout/theme.liquid). Geladen met defer. */
(function () {
  var RE = /<\/?tc>/g;
  function stripIn(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var v = node.nodeValue;
      if (v && (v.indexOf('<tc>') !== -1 || v.indexOf('</tc>') !== -1)) {
        node.nodeValue = v.replace(RE, '');
      }
    }
  }
  // Goedkope check vooraf: alleen de hele body doorlopen als er ergens nog een <tc>-tag in tekst staat
  function run() {
    var body = document.body;
    if (!body) return;
    var text = body.textContent || '';
    if (text.indexOf('<tc>') === -1 && text.indexOf('</tc>') === -1) return;
    stripIn(body);
  }

  function schedule() {
    // Meerdere passes om alle T-Lab translation rondes op te vangen
    [800, 2000, 4000, 7000, 12000, 20000].forEach(function (ms) {
      setTimeout(run, ms);
    });

    // Trigger op interactie met menu drawer / dropdowns (mobile)
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest(
        '[aria-controls*="menu"], [aria-controls*="drawer"], menu-drawer summary, .header__icon--menu, [data-header-drawer-toggle]'
      );
      if (trigger) {
        // Kleine delay zodat drawer eerst zichtbaar is voordat we strippen
        setTimeout(run, 50);
        setTimeout(run, 400);
        setTimeout(run, 1200);
      }
    }, { passive: true });

    // Trigger bij focusin op nav (keyboard nav opent dropdowns)
    var nav = document.querySelector('header, .header');
    if (nav) {
      nav.addEventListener('focusin', function () { setTimeout(run, 100); }, { passive: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
})();
